module.exports = __webpack_public_path__ + "static/media/fampay.5ab68111.png";